import axios from "axios";
const api = process.env.REACT_APP_SERVER_API_V2;

export default () => {
  axios.defaults.baseURL = api + 'sugoroku_events';
  return axios;
}